<template lang="html">
   <div id="parentx">

    <vs-sidebar default-index="1" :parent="parent" :hiddenBackground="doNotClose" color="primary" class="left-sidebar" spacer v-model="isSidebarActive" :click-not-close="doNotClose" :reduce="isSidebarReduced">

      <div class="header-sidebar text-center" slot="header">
        <vs-avatar size="70px" :src="user.avatar"/>
        <h4>{{ user.name }}<br/>
          <small>{{ user.email }}</small>
        </h4>
      </div>

      <div v-bar class="vs-scrollable">
      <div>
      <template v-for="(sidebarLink, index) in sidebarLinks">

        <!-- Small Cap -->
        <span v-if="sidebarLink.title"  :key="index + '.' + index" class="small-cap">{{ sidebarLink.title }}</span>
        <template v-else-if="!sidebarLink.title">
          <!-- Single Menu -->
          <vs-sidebar-item :key="sidebarLink.index" :icon-pack="sidebarLink.icon" :index="sidebarLink.index" v-if="!sidebarLink.child" :to="sidebarLink.url">
            <span class="hide-in-minisidebar">{{ sidebarLink.name }}</span>
          </vs-sidebar-item>
          <!-- Dropdown Menu -->
          <template v-else >
            <vs-sidebar-group :title="sidebarLink.name" :key="sidebarLink.index" :icon-pack="sidebarLink.icon" :open="isSubLinkActive(sidebarLink)">
              <li v-for="(subLink) in sidebarLink.child" :key="subLink.index">
                  <vs-sidebar-item :icon-pack="subLink.icon" :to="subLink.url" :index="subLink.index">
                    <span class="hide-in-minisidebar">{{ ubLink.name }}</span>
                  </vs-sidebar-item>
              </li>
          </vs-sidebar-group>
          <!-- /Dropdown Menu -->
        </template>
        </template>

      </template>
      </div>
      </div>

      <div class="footer-sidebar" slot="footer">
        <vs-button @click="logout" icon="reply" color="danger" type="flat"><span class="hide-in-minisidebar">log out</span></vs-button>
      </div>

    </vs-sidebar>

  </div>


</template>

<script>
import {AuthService} from "../../../services/auth.service";

export default {
  name: "SideBar",
  props: {
    parent: {
      type: String
    },
    sidebarLinks: {
      type: Array,
      required: true
    },
    subLink: {
      type: Object
    },
    index: {
      default: null,
      type: [String, Number]
    }
  },
  data: () => ({
    doNotClose: false,
    windowWidth: window.innerWidth,
    round: true
  }),
  computed: {
    // Data For User Dropdown
    user:  {
      get() {
        return {
          avatar: this.$store.state.user.currentUser.avatar,
          name: this.$store.state.user.currentUser.name,
          email: this.$store.state.user.currentUser.username
        };
      },
    },
    //This is for mobile trigger
    isSidebarActive: {
      get() {
        return this.$store.state.layout.isSidebarActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_SIDEBAR_ACTIVE", val);
      }
    },
    isSidebarReduced: {
      get() {
        return this.$store.state.layout.isSidebarReduced;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_SIDEBAR", val);
      }
    },
    //This is for active group link
    isSubLinkActive() {
      return sidebarLink => {
        let open = false;
        if (sidebarLink.child) {
          sidebarLink.child.forEach(link => {
            if (this.$route.fullPath == link.url) {
              open = true;
            }
          });
        }
        return open;
      };
    }
  },
  watch: {
    '$route'() {
      if(this.windowWidth < 1170 ) this.$store.commit('TOGGLE_SIDEBAR_ACTIVE', false);
    },
  },
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1170) {
        this.$store.commit("TOGGLE_SIDEBAR_ACTIVE", false);
        (this.doNotClose = false),
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else {
        this.$store.commit("TOGGLE_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
        if (this.isSidebarReduced)
          this.$store.dispatch("updateSidebarWidth", "mini");
        else this.$store.dispatch("updateSidebarWidth", "default");
      }
    },
    logout() {
      AuthService.makeLogout();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebarWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebarWidth();
  }
};
</script>
